module.exports = __webpack_public_path__ + "img/Lucas Torreira.7debce86.png";